<template>
  <AppLayout>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
      <div class="widget widget-six">
        <div class="widget-heading">
          <div class="row">
            <div class="col-12 d-inline-flex align-items-center">
              <h4 class="me-3 my-0">Zestawienia</h4>
            </div>
          </div>
        </div>

        <div class="widget-content">
          <div class="text-start mb-2 d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-3">
            <div class="d-flex align-items-center gap-2">
              <button class="btn btn-sm btn-info" :disabled="selectedYear <= minYear" @click="changeYear(-1)">←</button>
              <span class="mx-3">{{ selectedYear }}</span>
              <button class="btn btn-sm btn-info" :disabled="selectedYear >= currentYear" @click="changeYear(1)">→
              </button>
            </div>
            <div class="col-md-6 d-flex align-items-center gap-3 flex-wrap mt-2 mt-sm-0">
              <label class="switch s-icons s-outline s-outline-info">
                <input type="checkbox" v-model="archivedServicesShown" @change="fetchData">
                <span class="slider round"></span>
              </label>
              <label class="form-check-label">Pokaż zarchiwizowane</label>
              <label class="switch s-icons s-outline s-outline-info">
                <input type="checkbox" v-model="hiddenServicesShown" @change="fetchData">
                <span class="slider round"></span>
              </label>
              <label class="form-check-label">Pokaż ukryte</label>
            </div>
          </div>

          <div class="custom-table table-responsive mt-2">
            <table class="table table-bordered table-hover">
              <thead>
              <tr>
                <th @click="sortBy('name')" class="text-start">Klient <span
                    v-if="sortKey === 'name'">{{ sortOrders['name'] > 0 ? '▲' : '▼' }}</span></th>
                <th @click="sortBy('company')" class="text-center">Koszt serwisu <span
                    v-if="sortKey === 'company'">{{ sortOrders['company'] > 0 ? '▲' : '▼' }}</span></th>
                <th @click="sortBy('client')" class="text-center">Koszt klienta <span
                    v-if="sortKey === 'client'">{{ sortOrders['client'] > 0 ? '▲' : '▼' }}</span></th>
                <th @click="sortBy('profit')" class="text-center">Różnica <span
                    v-if="sortKey === 'profit'">{{ sortOrders['profit'] > 0 ? '▲' : '▼' }}</span></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="c in sortedCustomers" :key="c.id">
                <td class="text-start">{{ c.name }}</td>
                <td class="text-end">{{ formatMoney(c.company) }}</td>
                <td class="text-end">{{ formatMoney(c.client) }}</td>
                <td class="text-end">{{ formatMoney(c.client - c.company) }}</td>
              </tr>
              <tr class="fw-bold bg-light">
                <td class="bg-gray-100 text-end"><strong>RAZEM:</strong></td>
                <td class="bg-gray-100 text-end"><strong>{{ formatMoney(totalCompany) }}</strong></td>
                <td class="bg-gray-100 text-end"><strong>{{ formatMoney(totalClient) }}</strong></td>
                <td class="bg-gray-100 text-end"><strong>{{ formatMoney(totalProfit) }}</strong></td>
              </tr>
              </tbody>
            </table>
          </div>

          <div
              class="col-12 text-start mt-2 mb-2 d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-3">
            <div class="col-md-6 d-flex align-items-center gap-2">
              <button class="btn btn-sm btn-info" :disabled="selectedYear <= minYear" @click="changeYear(-1)">←</button>
              <span class="mx-3">{{ selectedYear }}</span>
              <button class="btn btn-sm btn-info" :disabled="selectedYear >= currentYear" @click="changeYear(1)">→
              </button>
            </div>
            <div class="col-md-6 mt-2 mt-sm-0">
              <select v-model="selectedCustomer" class="form-select form-select-sm" @change="fetchData">
                <option :value="null">Wszyscy klienci</option>
                <option v-for="c in customers" :key="c.id" :value="c.id">{{ c.name }}</option>
              </select>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-md-6 mb-4">
              <h5>Zestawienie serwisów</h5>
              <apexchart type="bar" height="350" :options="chartOptions" :series="chartSeries"/>
            </div>
            <div class="col-md-6 mb-4">
              <h5>Koszty serwisów (klient vs firma)</h5>
              <apexchart type="bar" height="350" :options="chartOptionsCostsCompare" :series="chartSeriesCostsCompare"/>
            </div>
          </div>

        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import axios from 'axios';
import vueApexcharts from "vue3-apexcharts";

export default {
  components: {AppLayout, apexchart: vueApexcharts},
  data() {
    return {
      archivedServicesShown: false,
      hiddenServicesShown: false,
      selectedYear: new Date().getFullYear(),
      selectedCustomer: null,
      customers: [],
      currentYear: new Date().getFullYear(),
      minYear: 2020,
      customerData: [],
      sortKey: '',
      sortOrders: {name: 1, company: 1, client: 1, profit: 1},
      chartOptions: {
        chart: {id: 'wykres_serwisow'},
        xaxis: {categories: ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII']},
        plotOptions: {bar: {horizontal: false}},
        dataLabels: {enabled: false},
        yaxis: {min: 0, forceNiceScale: true},
        tooltip: {},
        legend: {show: true}
      },
      chartSeries: [
        {name: "Nowe", data: []},
        {name: "Zakończone", data: []},
      ],
      chartOptionsCostsCompare: {
        chart: {id: 'wykres_kosztow_porownanie'},
        xaxis: {categories: ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII']},
        plotOptions: {bar: {horizontal: false, columnWidth: '60%'}},
        dataLabels: {enabled: false},
        yaxis: {title: {text: 'Koszty'}},
        tooltip: {y: {formatter: val => val.toLocaleString('pl-PL')}},
        legend: {show: true}
      },
      chartSeriesCostsCompare: [
        {name: "Koszt klienta", data: []},
        {name: "Koszt firmy", data: []},
      ],
    };
  },
  computed: {
    sortedCustomers() {
      if (!this.sortKey) return this.customerData;
      return [...this.customerData].sort((a, b) => {
        const order = this.sortOrders[this.sortKey];
        if (this.sortKey === 'name') return a.name.localeCompare(b.name) * order;
        return (a[this.sortKey] - b[this.sortKey]) * order;
      });
    },
    totalCompany() {
      return this.customerData.reduce((sum, c) => sum + (c.company || 0), 0);
    },
    totalClient() {
      return this.customerData.reduce((sum, c) => sum + (c.client || 0), 0);
    },
    totalProfit() {
      return this.totalClient - this.totalCompany;
    }
  },
  watch: {
    selectedYear: {
      handler() {
        this.fetchData(true);
      },
      immediate: true
    },
    selectedCustomer: {
      handler() {
        this.fetchData(false);
      }
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    changeYear(delta) {
      this.selectedYear += delta;
    },
    sortBy(key) {
      if (this.sortKey === key) this.sortOrders[key] *= -1;
      else this.sortKey = key;
    },
    formatMoney(val) {
      return val.toLocaleString('pl-PL', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    },
    fetchData(updateTable = false) {
      axios.get('/service/zestawienia/data', {
        params: {
          year: this.selectedYear,
          customer_id: this.selectedCustomer, // tylko dla wykresów
          showArchived: this.archivedServicesShown,
          showHidden: this.hiddenServicesShown,
        }
      }).then(res => {
        if (updateTable && res.data.customers) {
          this.customerData = res.data.customers.map(c => ({
            ...c,
            profit: (c.client ?? 0) - (c.company ?? 0)
          }));
        }

        this.customers = this.customerData.map(c => ({id: c.id, name: c.name}));

        const data = res.data;
        this.chartSeries[0].data = data.monthly_open_counts.slice(1);
        this.chartSeries[1].data = data.monthly_counts.slice(1);

        const clientCosts = data.monthly_total_costs.slice(1);
        const companyCosts = data.monthly_total_cost_company.slice(1).map(v => -v);
        this.chartSeriesCostsCompare[0].data = clientCosts;
        this.chartSeriesCostsCompare[1].data = companyCosts;

        this.chartSeries = [...this.chartSeries];
        this.chartSeriesCostsCompare = [...this.chartSeriesCostsCompare];
      });
    }


  }
};
</script>
<style scoped>
.bg-gray-100 {
  background-color: #f5f5f5;
  color: black;
}
</style>